import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import { RadioButtonsGroup } from '@components/RadioButtonsGroup';

export const InfoWrapper = styled('div')({
    marginBottom: 24,
    display: 'flex',
    flexDirection: 'column',
});

export const UnsubscribeWrapper = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    '& .MuiCheckbox-root': {
        padding: 0,
    },
});

export const ActivityWrapper = styled('div')({
    display: 'grid',
    gridGap: '0 10px',
    gridTemplateColumns: '14px 1fr 60px',
    '&:not(:last-child)': {
        marginBottom: 24,
    },
    '& svg': {
        transform: 'translateY(2px)',
    },
});

export const IconWrapper = styled('span')({
    '& svg': {
        transform: 'translateY(0)',
    },
    '& svg path': {
        fill: '#1F4C5C',
        fillOpacity: 1,
    },
});

export const CustomEventDataRaw = styled('pre')({
    margin: 0,
    whiteSpace: 'pre-wrap',
    fontFamily: 'inherit',
    fontSize: 'inherit',
    lineHeight: '1.4',
});

export const RadioButtonsWrapper = styled('div')({
    overflowX: 'initial',
    height: 32,
    marginBottom: 24,
    msOverflowStyle: 'none',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
        display: 'none',
    },
    '@media (max-width: 768px)': {
        overflowX: 'auto',
    },
});

export const RadioButtons = styled(RadioButtonsGroup)({
    width: '100%',
    display: 'block',
    marginBottom: '24px',
    '& .MuiFormControlLabel-root': {
        height: '32px',
        padding: '0 4px',
    },
});

export const StyledIconButton = styled(IconButton)({
    borderRadius: '50%',
    '&.Mui-disabled': {
        pointerEvents: 'auto',
        cursor: 'pointer',
    },
    '& svg': {
        width: 24,
        height: 24,
        '& path': {
            fill: 'rgba(0, 0, 0, 0.6)',
            fillOpacity: 1,
        },
    },
});
